export default __webpack_public_path__ + "static/media/lk.4e85528b.jpg";